export * from './kommunikation.querys.module';
